/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Segment_Help_Entire_VideoInputs */

const en_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The entire video will be sent to the AI. Turn this off to limit processing to a specific segment.`)
};

const fr_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vidéo entière sera envoyée à l'IA. Désactivez cette option pour limiter le traitement à un segment spécifique.`)
};

const de_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das gesamte Video wird an die KI gesendet. Deaktivieren Sie diese Option, um die Verarbeitung auf einen bestimmten Abschnitt zu beschränken.`)
};

const it_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'intero video verrà inviato all'IA. Disattiva questa opzione per limitare l'elaborazione a un segmento specifico.`)
};

const ru_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Всё видео будет отправлено искусственному интеллекту. Отключите эту функцию, чтобы ограничить обработку определённым сегментом.`)
};

const es_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El vídeo completo se enviará a la IA. Desactive esta opción para limitar el procesamiento a un segmento específico.`)
};

const zh_cn2_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`整个视频将发送给人工智能。关闭此选项可将处理范围限制在特定片段。`)
};

const ja_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画全体がAIに送信されます。処理対象を特定のセグメントに限定するには、この設定をオフにしてください。`)
};

const hi_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूरा वीडियो एआई को भेजा जाएगा। किसी विशिष्ट सेगमेंट तक प्रोसेसिंग सीमित करने के लिए इसे बंद कर दें।`)
};

const pt_pt2_ad_segment_help_entire_video = /** @type {(inputs: Ad_Segment_Help_Entire_VideoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O vídeo inteiro será enviado para a IA. Desative esta opção para limitar o processamento a um segmento específico.`)
};

/**
* | output |
* | --- |
* | "The entire video will be sent to the AI. Turn this off to limit processing to a specific segment." |
*
* @param {Ad_Segment_Help_Entire_VideoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_segment_help_entire_video = /** @type {((inputs?: Ad_Segment_Help_Entire_VideoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Segment_Help_Entire_VideoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_segment_help_entire_video(inputs)
	if (locale === "de") return de_ad_segment_help_entire_video(inputs)
	if (locale === "it") return it_ad_segment_help_entire_video(inputs)
	if (locale === "ru") return ru_ad_segment_help_entire_video(inputs)
	if (locale === "es") return es_ad_segment_help_entire_video(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_segment_help_entire_video(inputs)
	if (locale === "ja") return ja_ad_segment_help_entire_video(inputs)
	if (locale === "hi") return hi_ad_segment_help_entire_video(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_segment_help_entire_video(inputs)
	return en_ad_segment_help_entire_video(inputs)
});